import { ArtistProductSummary } from "src/app/Services/artistproducts.service";
import { ArtistPerformingSeriesDashboardResponse, RecentConsignmentResponse } from "./artistdashboard.models";

export interface ArtistOverlayDashboardResponse {
    ArtistBestSellingSeries?: ArtistPerformingSeriesDashboardResponse[];
    RecentConsignments?: RecentConsignmentResponse[];
    HighPerformingArtworksBySalesValue?: ArtistProductSummary[];
    HighPerformingArtworksByTurnover?: ArtistProductSummary[];
    HighPerformingArtworksBySeries?: ArtistProductSummary[];
    ArtistInsightsSeriesData?: ArtistInsightsSeries[];
}

export class ArtistInsightsSeries {
    Metric!: ArtistSalesInsightsMetricsType;
    SeriesName!: string;    //the description of the metric (in human readable format)
    // SeriesValues!: ArtistInsightsMonthlyBreakdownValue[];
    ChartsValue!: ChartsValue[];
}

// export class ArtistInsightsMonthlyBreakdownValue {
//     // Month!: number;
//     // Year!: number;
//     // Value!: number;
//     // MonthName!: string;
// }

export enum ArtistSalesInsightsMetrics {
    TotalSales = 'TotalSales',
    TotalArtworksSold = 'TotalArtworksSold',
    AverageTurnOverTimes = 'AverageTurnOverTimes',
    ArtworksInInventory = 'ArtworksInInventory',
}

export enum AdminDashboardInsightMetrics{
    TotalPaidInvoiceAmount = 'TotalPaidInvoicesAmount',
    TotalPaidInvoices = 'TotalPaidInvoices'
}
export type ArtistSalesInsightsMetricsType = ArtistSalesInsightsMetrics.TotalSales | ArtistSalesInsightsMetrics.TotalArtworksSold
   | ArtistSalesInsightsMetrics.AverageTurnOverTimes | ArtistSalesInsightsMetrics.ArtworksInInventory;

export type AdminDashboardInsightMetricsType = AdminDashboardInsightMetrics.TotalPaidInvoiceAmount | AdminDashboardInsightMetrics.TotalPaidInvoices;

export enum ArtistSalesInsightsMetricsColors {
    TotalSales = '--blue-500',
    TotalArtworksSold = '--pink-500',
    AverageTurnOverTimes = '--green-500',
    ArtworksInInventory = '--yellow-500'
}

export enum AdminSubscriptionInsightsMetricsColors {
    TotalPaidInvoiceAmount = '--blue-500',
    TotalPaidInvoices = '--pink-500',
}

export class PrimengDataSet{
    labels!: string[];
    datasets!: DataSets[]
}
// export class GetStripeData {
//     TotalInvoice!: string;
//     TotalPaidAmount!: string;
//     MonthlyInvoices!: MonthlyInvoice[];
//   }
  
//   export class MonthlyInvoice {
//     MonthYear!: string;
//     Month!: string;
//     Year!: string;
//     TotalPaidAmount!: number;
//     InvoicesCount!: number;
//   }
  
export class DataSets{
    label!: string | undefined;
    data!: number[];
    dataPointLabels!: string[];
    fill!: boolean;
    borderColor!: string;
    tension!: number
}

export class AdminDashboardApiResponce {
    totalExecutionSecons!: number;
    TotalArtistProducts!: number;
    ArtistAccounts!: ArtistAccounts;
    GalleryAccounts!: GalleryAccounts;
    StripeInsightsCharts!: StripeInsightsChart[];
}

export class ArtistAccounts {
    TotalArtist?: number;
    TotalProArtist?: number;
    TotalFreeArtist?: number;
}

export class GalleryAccounts {
    TotalGallery!: number;
    TotalProGallery!: number;
    TotalFreeGallery!: number;
}

export class StripeInsightsChart {
    Metric!: AdminDashboardInsightMetricsType;
    SeriesName!: string;
    ChartsValue!: ChartsValue[];
    TopSummaryStatus!: string;
}

export class ChartsValue {
    Label!: string;
    DataLabel!: string
    Value!: number;
}

// export class MonthlyInvoices {
//     MonthYear!: string;
//     Month!: string;
//     Year!: string;
//     TotalPaidAmount!: number;
//     InvoicesCount!: number;
// }
